function getFullName(patient) {
  return patient.lastName
    ? `${patient.lastName}, ${patient.firstName}`
    : patient.firstName;
}

export default getFullName;
